import pick from 'FileManagerCore/utils/pick';
import { FILE_UPLOAD_V3_OPTION_KEYS } from 'FileManagerCore/constants/propTypes';
export const pickValidUploadV3Options = (options = {}) => pick(options, FILE_UPLOAD_V3_OPTION_KEYS);